module.exports = __webpack_public_path__ + "static/media/spot.e88c16c4.svg";